"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotStyled = exports.TabItemStyled = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const Color_enum_1 = require("../../constants/Color.enum");
exports.TabItemStyled = styled_components_1.default.div `
    display: flex;
    user-select: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 10px;
    color: ${(props) => (props.isSelected ? Color_enum_1.Color.Black : Color_enum_1.Color.Secondary)};
    font-size: 12px;
    line-height: 20px;
    letter-spacing: 0.75px;
    cursor: pointer;
    opacity: ${(props) => (props.disabled ? 0.3 : 'initial')};
    pointer-events: ${(props) => (props.disabled ? 'none' : 'initial')};
    border: 8px solid transparent;
    border-radius: 100px;
    text-transform: uppercase;
    white-space: nowrap;
    margin: 0 -10px;

    &:first-child {
        margin-left: 0;
    }

    &:last-child {
        margin-right: 0;
    }

    &:hover {
        color: ${(props) => (props.canGreyout ? Color_enum_1.Color.Secondary : Color_enum_1.Color.Black)};
    }
    &:focus {
        background: ${Color_enum_1.Color.Variant_1};
        border-color: ${Color_enum_1.Color.Variant_1};
    }
`;
const DOT_DIMENSION = '4px';
exports.DotStyled = styled_components_1.default.div `
    height: ${DOT_DIMENSION};
    width: ${DOT_DIMENSION};
    bottom: 15px;
    z-index: 1;
    position: absolute;
    background-color: ${Color_enum_1.Color.Primary};
    border-radius: 50%;
    transform: ${(props) => `translateX(calc(${props.position}px - calc(${DOT_DIMENSION} / 2)))})`};
    transition: transform 0.3s ease-in;
    opacity: ${(props) => (props.disabled ? 0.3 : 'initial')};
`;
